"use client";

import { useState } from "react";

export function CompareSlider() {
  const [value, setValue] = useState(50);

  return (
    <div className="compare-stage">
      <span className="compare-label l">TYPICAL CLIP</span>
      <span className="compare-label r">BASALT</span>
      <div className="compare-half before">
        <svg width="140" height="160" viewBox="0 0 140 160">
          <rect x="55" y="10" width="14" height="140" fill="#6B6B6B" />
          <path
            d="M55 40 Q20 55 30 85 Q38 105 55 100"
            fill="none"
            stroke="#9C9C9C"
            strokeWidth={8}
            strokeLinecap="round"
          />
        </svg>
      </div>
      <div className="compare-half after" style={{ clipPath: `inset(0 0 0 ${value}%)` }}>
        <svg width="140" height="160" viewBox="0 0 140 160">
          <rect x="55" y="10" width="14" height="140" fill="#EDEDEC" />
          <path
            d="M40 35 Q10 60 22 95 Q34 128 66 122 Q98 116 96 80 Q94 48 68 38 Z"
            fill="none"
            stroke="#1B1B1B"
            strokeWidth={10}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M40 35 Q10 60 22 95 Q34 128 66 122 Q98 116 96 80 Q94 48 68 38 Z"
            fill="none"
            stroke="#F7F7F6"
            strokeWidth={3}
            strokeDasharray="2 4"
          />
        </svg>
      </div>
      <input
        className="compare-handle"
        type="range"
        min={0}
        max={100}
        value={value}
        onChange={(e) => setValue(Number(e.target.value))}
        aria-label="Drag to compare official mount and Basalt mount"
      />
    </div>
  );
}
